// pages/Image/AddImage.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import ListImages from './ListImages';
import { Tabs, Tab } from '@mui/material';
import backendURL from "../../config";

export default function AddImages() {
  useEffect(() => {
    document.title = 'Upload Image | KlonIT Web Application';
  }, []);

  const [selectedFiles, setSelectedFiles] = useState(null);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Loading state

  const handleFileChange = (event) => {
    setSelectedFiles(event.target.files);
  };

  const handleFileUpload = async () => {
    if (!selectedFiles) {
      alert("Please select file(s) to upload.");
      return;
    }
    setError(null);
    setIsLoading(true); // Show spinner
    const formData = new FormData();
    for (let i = 0; i < selectedFiles.length; i++) {
      const file = selectedFiles[i];
      formData.append("files", file);
    }

    const token = localStorage.getItem('access_token');

    try {
      const response = await axios.post(`${backendURL}/upload-image`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        },
      });

      console.log("Upload successful:", response.data);
      setError(response.data.message);
      setSelectedFiles(null); const fileInput = document.getElementById('input-20'); if(fileInput) fileInput.value = '';

      // Trigger refresh after successful upload
      setRefresh(prev => !prev);

    } catch (error) {
      console.error("Error uploading files:", error);
      if (error.response) {
        setError(error.response.data.message);
      }
    } finally {
      setIsLoading(false); // Hide spinner
    }
  };

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <div>
      <main className="content">
        <div className="container-fluid p-0">
          <div className="mb-3">
            <h1 className="h3 d-inline align-middle"><strong>Manage</strong> Images</h1>
          </div>
          <div className="row">
            <div className="col-12 col-lg-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title mb-0">
                    Upload Images
                  </h5>
                </div>
                <div className="card-body">
                <div>
                      {/* Upload */}
                    <label htmlFor="input-20" className="form-label text-center w-100">
                      Upload Files (.jpg, .jpeg, .png)
                    </label>
                    <div className="d-flex justify-content-center align-items-center">
                      <input
                        className="form-control me-2 p-2"
                        id="input-20"
                        type="file"
                        multiple
                        accept=".jpg,.jpeg,.png"
                        onChange={handleFileChange}
                        disabled={isLoading}
                        style={{ maxWidth: '300px' }}
                      />
                      <button className="btn btn-primary mb-3" onClick={handleFileUpload} disabled={isLoading}>
                        {isLoading ? (
                          <>
                            <i className="fa fa-spinner fa-spin"></i> Uploading...
                          </>
                        ) : (
                          "Upload Files"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
                <br />
                <div id="getError" className={`alert alert-warning ${error ? "" : "d-none"}`}>{error}</div>
              </div>
            </div>
          </div>

          {/* MUI Tabs for switching between ListImages and other components */}
          <Tabs value={activeTab} onChange={handleChange} aria-label="image tabs">
            <Tab label="List Images" />
            {/* <Tab label="Image Scrape" /> */}
          </Tabs>

          <div className="tab-content">
            {activeTab === 0 && <ListImages refresh={refresh} />}
            {/* {activeTab === 1 && <ImageScrape />} */}
          </div>
        </div>
      </main>
    </div>
  );
}
